module.exports = __webpack_public_path__ + "src/assets/img/card-2.23f030e9.svg";